import { graphql } from 'src/gql';

export const HouseholdAccountFragment = graphql(/* GraphQL */ `
  fragment HouseholdAccount on Household {
    id
    uuid
    name
    adviceOnly
    advisorAnnualRevenue
    lastContactAt
    salesforceAccountId
    savvyAum
    orionHouseholdId
    householdStage
    demo
    hasActiveEciOnboarding
    bookOnboardingCockpit @include(if: $includeBookOnboardingCockpit) {
      ...HouseholdOnboardingStatusRibbonRow
    }
    advisor {
      id
    }
    prospectData {
      estimatedAum
    }
    primaryClient {
      id
      user {
        id
        firstName
        lastName
        email
        phoneNumber
      }
    }
    coClient {
      id
      user {
        id
        firstName
        lastName
        email
        phoneNumber
      }
    }
  }
`);
